module.exports = __webpack_public_path__ + "img/expandactive.48a25f35.svg";